export default __webpack_public_path__ + "73ce24bf6414a9bd7fa2c19c164cf680.svg";